<ew-mat-dialog-custom
  class="overflow-hidden grid grid-rows-[1fr_1px_auto] h-full">
  <div class="mx-10 mt-8">
    <h1 class="text-2xl font-semibold text-gray-800 mb-4">
      {{ 'settingsUsers:editUserNameTitle' | translate }}
    </h1>

    <div class="my-6">
      <p class="mb-4 text-gray-600">
        {{ 'settingsUsers:email' | translate }}
      </p>
      <p class="mb-4 text-gray-600">
        {{ currentEmail }}
      </p>
      <p class="mb-4 text-gray-600">
        {{ 'settingsUsers:editUserNameMessage' | translate }} *
      </p>
      <mat-form-field appearance="outline" class="w-full">
        <input
          matInput
          [formControl]="userNameControl"
          class="input-height text-center" />
        <mat-error *ngIf="userNameControl.hasError('required')">
          {{ 'shared:isRequired' | translate }}
        </mat-error>
        <mat-error *ngIf="userNameControl.hasError('maxlength')">
          {{ 'shared:maxLength' | translate }} 255
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <hr class="w-full m-0 mt-6" />

  <div class="mx-10 py-6 flex justify-end gap-4">
    <button
      mat-stroked-button
      class="rounded-lg h-10 min-w-[100px]"
      color="secondary"
      [disabled]="loading"
      (click)="dialogRef.close()">
      {{ 'shared:cancel' | translate }}
    </button>

    <button
      mat-flat-button
      class="rounded-lg h-10 min-w-[150px]"
      color="primary"
      [disabled]="loading || userNameControl.invalid"
      (click)="editUserName()">
      <span *ngIf="!loading" class="flex items-center justify-center gap-2">
        <mat-icon class="text-base">edit</mat-icon>
        {{ 'settingsUsers:editUserButton' | translate }}
      </span>
      <mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner>
    </button>
  </div>
</ew-mat-dialog-custom>
